<template>
    <div>
        <div class="modal fade" id="emailTemplateModal" tabindex="-1" role="dialog" aria-labelledby="emailTemplateModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="emailTemplateModalLabel">Email Template</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">

                        <form>

                            <div class="mb-3">
                                <label for="subjectInput">Subject</label>
                                <input type="text" class="form-control" id="subjectInput" v-model="emailTemplate.subject">
                            </div>

                            <div id="emailBodyContainer" class="form-group">
                                <label for="subjectInput">Email</label>

<!--                                <VueTrix ref="vueTrix" inputId="emailBodyInput" v-model="emailTemplate.body" placeholder="Email Content"-->
<!--                                         @trix-focus="onFocus" @trix-blur="onFocusOut"/>-->

                                <vue3-trix-editor input-id="emailTemplateTextEditor" :model-object="emailTemplate" text-field="body"
                                    @onFocus="onFocus" @onFocusOut="onFocusOut"></vue3-trix-editor>

                            </div>

                        </form>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler" >Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import EmailTemplatesService from "../services/EmailTemplatesService";
    import Vue3TrixEditor from "../components/Vue3TrixEditor.vue";

    export default {
        name: 'EmailTemplateModal',
        components: {
            Vue3TrixEditor
        },
        props: {
            yesEvent: Function,
            emailTemplate: Object
        },
        data () {
            return {
                model: webase.model,
                service: new EmailTemplatesService(),
                timerId: null,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('emailTemplateModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {

                this.save()

                // call the parent's "yesEvent"
                if(this.yesEvent) {
                    this.yesEvent()
                }
                // hide the modal
                this.noHandler()
            },
            save() {
                if (this.emailTemplate.id === null) {
                    this.create()
                } else {
                    this.update()
                }
            },
            create() {
                let request = {
                    email_template: this.emailTemplate
                }

                this.service.create(request).then((response) => {
                    console.log('email_template created')
                    this.emailTemplate.id = response.id
                    // this.model.app.integrations.push(response)
                }).catch((message) => {
                    console.log('error creating email_template')
                    console.log(message)
                })
            },
            update() {
                let request = {
                    email_template: this.emailTemplate
                }

                this.service.update(this.emailTemplate.id, request).then((response) => {
                    console.log('email_template updated')
                }).catch((message) => {
                    console.log('error updating email_template')
                    console.log(message)
                })
            },

            onFocus() {
                console.log('starting timer')
                this.timerId = setInterval(this.save, 5000);
                console.log('timer id: ' + this.timerId)
            },
            onFocusOut() {
                if(this.timerId) {
                    console.log('stopping timer')
                    clearInterval(this.timerId)
                }

                this.timerId = null
                this.save()
            },
        }
    }
</script>
